exports.inject = function(module) {
  module.controller('AddRecordController', exports.controller);
  exports.controller.$inject = ['$scope', '$rootScope', '$location', '$window','$timeout', '$route', 'Numbers', '$http', 'Auth', 'Api', 'modals', '$q', '$cookies', 'gtmJS', 'ENV'];
};

exports.controller = function($scope, $rootScope, $location, $window, $timeout, $route, Numbers, $http, Auth, Api, modals, $q, $cookies, gtmJS, env) {
  var initAddNumberModalData = function() {
    $scope.areaCodeError = false;

    $scope.numbers = [];

    $scope.showCountryName = 'United States';

    $scope.search = "";

    $scope.showCountry = false;

    $scope.SENT_REQUEST = false;

    $scope.LOADED = false;

    $scope.INFO = {
      areaCode: '',
      name: '',
      voiceover: '',
      voiceoverSave: false,
      copyFrom: 'Bridge to copy settings from',
      selectedCopyFrom: false
    };

    $scope.search_number = {step: 0, tie: null};
    $scope.smsVerification = {step: 0};
  };

  function getCountryNumbers(tollFreeNumbers) {
    var country = !$scope.showCountry ? 'US' : $scope.showCountry;
    $scope.LOADED = true;
    $scope.SENT_REQUEST = true;
    $scope.numbers = [];
    $scope.search = $scope.INFO.areaCode;
    $scope.tollfree = !!tollFreeNumbers;

    var data = {
      country: country,
      code: $scope.INFO.areaCode || null
    };

    if ($scope.search_number.tie) {
      var tiedBridge = $scope.MODEL.filter(function(b) {
        return b.id === $scope.search_number.tie;
      })[0] || {};

      data.service_provider = tiedBridge.service_provider;
      data.bridge_id = tiedBridge.id;
    }

    if(tollFreeNumbers) {
      data = {number_type: 'tollfree'};
    }

    Numbers.getNumbers(data).then(function(response) {
      $scope.LOADED = false;
      var grouped = [];
      var numbers = response.data.numbers.slice(0, 50);
      for(var i = 0; i < numbers.length; i++) {
        var number = numbers[i];
        if(i % 3 === 0) {
          grouped.push([number]);
        } else {
          grouped[grouped.length - 1].push(number);
        }
      }
      $scope.numbers = grouped;
    });
  }

  function verifyUser(user) {
    if (user.verified) {
      return true;
    }

    if ($scope.userInfo.company.require_sms) {
      return false;
    }

    var hoursNow = moment(new Date()).tz('America/New_York').hours();
    var inv = env.SKIP_VERIFICATION_INTERVAL;
    if (hoursNow >= inv[0] && hoursNow <= inv[1]) {
      return null;
    }

    return false;
  }

  $rootScope.showAddNumberModal = function($event) {
    initAddNumberModalData();
    if($event && $event.preventDefault) {
      $event.preventDefault();
    }
    // check if user is verified
    var isVerified = verifyUser($scope.userInfo.company);
    if(isVerified === false) {
      return $scope.$broadcast('sms-verify-number-modal');
    } else if (isVerified === null) {
      return $scope.verifySmsCode(null, env.SKIP_VERIFICATION_CODE);
    }

    // Check if the user can add more numbers.
    if (!$scope.MODEL || $scope.MODEL.length >= $scope.userInfo.plan.max_lines) {
      $scope.max_lines = $scope.userInfo.plan.max_lines;
      return $scope.$broadcast('max-lines-reached-modal');
    }

    if ($cookies.get('buyNumber')) {
      $scope.LOADED = true;
      $scope.addNewLineModal = modals.addNewLine($scope).modal();

      var cookie = $cookies.get('buyNumber');
      var parts = cookie.split(':');
      var number = parts[1] || parts[0];
      var provider = parts[1] ? parts[0] : '';
      $scope.buyThisNumber({number: number, service_provider: provider});

      $cookies.remove('buyNumber', {domain: '.brandedbridgeline.com'});
      return;
    }

    $scope.openAddNumberModal();
  };

  $scope.openAddNumberModal = function() {
    // skip the tied-line step if there's no existing bridge yet
    var step = +!$scope.MODEL.length;
    $scope.search_number = {step: step, tie: null};

    $scope.addNewLineModal = modals.addNewLine($scope).modal();
  };

  $scope.$on('sms-verify-number-modal', function() {
    $scope.smsVerification.err = null;
    $scope.smsVerification.step = 0;

    $scope.smsVerifyModal = modals.smsVerify($scope).modal();
  });

  $scope.$on('max-lines-reached-modal', function() {
    $scope.maxLinesModal = modals.maxLines($scope).modal();
  });

  $scope.showUpgradeModal = function() {
    $scope.addNewLineModal.modal('hide');

    modals.upgr212($scope).modal();
  };

  $scope.showSelectCountry = function($event) {
    $event.preventDefault();
    $scope.showCountry = 'US';
    $scope.INFO.areaCode = "";
  };

  $scope.showTollFreeNumbers = function($event) {
    $event.preventDefault();

    if($scope.userInfo.plan.trial_period_days > 0) {
      return ($scope.showTollFreeNotice = true);
    }

    getCountryNumbers(true);
    $scope.SENT_REQUEST = false;
    $scope.numbers = [];
  };

  $scope.selectCountry = function($event, countryCode) {
    $event.preventDefault();
    $scope.showCountry = countryCode;
    $scope.showCountryName = $($event.target).text();
  };

  $scope.sendSmsCode = function($event, sms_number) {
    $scope.smsVerification.err = null;
    $event.preventDefault();

    if(!sms_number || (sms_number.match(/\d/g) || []).length < 10) {
      gtmJS.push(gtmJS.events.ACC_VERIFICATION_INVALID_NUMBER);
      $scope.smsVerification.err = 'Doesn\'t look like a valid phone number';
      return;
    }

    $scope.smsVerification.loading = true;
    $http({
      url: '/accounts/api/v1/send_sms_code/' + sms_number + '/',
      method: 'POST',
      data: {},
    }).then(function(response) {
      if(((response || {}).data || {}).success !== true) {
        gtmJS.push(gtmJS.events.ACC_VERIFICATION_INVALID_NUMBER);
        $scope.smsVerification.err = 'That\'s not a valid number we can send SMS to.';
        return;
      }

      $scope.smsVerification.err = null;
      $scope.smsVerification.step = 1;
      gtmJS.push(gtmJS.events.ACC_VERIFICATION_SMS_SENT);
    }, function(e) {
      $scope.smsVerification.err = 'Sorry, there was a network error, please try again!';
      throw e;
    }).then(function() {
      $scope.smsVerification.loading = false;
    });
  };

  $scope.verifySmsCode = function($event, code_entered) {
    $scope.smsVerification.err = null;

    if ($event) {
      $event.preventDefault();
    }

    $http({
      url: '/accounts/api/v1/verify_sms_code/' + code_entered + '/',
      method: 'POST',
      data: {code: code_entered},
    }).then(function(response) {
      if(response.data.success !== true) {
        gtmJS.push(gtmJS.events.ACC_VERIFICATION_WRONG_CODE);
        $scope.smsVerification.err = response.data.msg;
        return;
      }

      $scope.smsVerification.err = null;

      Auth.getCompanyInfo().then(function(response) {
        $scope.userInfo.company.verified = response.verified;

        if ($scope.smsVerifyModal) {
          $scope.smsVerifyModal.modal('hide');
        }

        gtmJS.push(gtmJS.events.ACC_VERIFICATION_VERIFIED);
        $scope.showAddNumberModal();
      });
    }, function(e) {
      $scope.smsVerification.err = 'srv_err';
      throw e;
    });
  };

  $scope.searchNumber = function($event) {
    $event.preventDefault();

    $scope.reqError = false;
    $scope.areaCodeError = false;

    var code = ($scope.INFO.areaCode || '').toString().slice(0, 3);
    var planCost = parseFloat($scope.userInfo.plan.price);
    var isFreeTrialUser = $scope.userInfo.plan.trial_period_days > 0;
    var tollFreePrefs = ['800', '844', '855', '866', '877', '888'];

    if(isFreeTrialUser && tollFreePrefs.indexOf(code) > -1) {
      $scope.reqError = 'Toll-free are not available for trials!';

      $scope.SENT_REQUEST = false;
      $scope.numbers = [];
      return;
    }

    $scope.showIndiaNotice = $scope.showCountryName == 'India' && $scope.userInfo.plan.id != 33;

    var is212 = $scope.INFO.areaCode && $scope.INFO.areaCode.toString() == '212';

    if(is212 && planCost < 100) {
      return $scope.showUpgradeModal();
    }

    if(!$scope.showIndiaNotice){
      gtmJS.push(gtmJS.events.NUMBER_SEARCH);
      return getCountryNumbers();
    }

    $scope.SENT_REQUEST = false;
    $scope.numbers = [];
  };

  $scope.parseAreaCode = function() {
    if (!$scope.INFO.areaCode) {
      return;
    }

    $scope.areaCodeError = false;
    var areaCode = (($scope.INFO.areaCode || '').match(/\d/g) || []).slice(0, 3).join('');
    if (areaCode !== $scope.INFO.areaCode) {
      $scope.areaCodeError = true;
      $scope.INFO.areaCode = areaCode;
    }
  };

  $scope.checkNumber = function($event, number) {
    $event.preventDefault();

    if($scope.tollfree) {
      $scope.addNewLineModal.modal('hide');

      $scope.tollFreeModal = modals.tollFree($scope).modal();
      $scope.buyNumber = $scope.buyThisNumber.bind(null, number);
    } else {
      $scope.LOADED = true;
      $scope.buyThisNumber(number);
    }
  };

  $scope.buyThisNumber = function(number) {
    gtmJS.push(gtmJS.events.NUMBER_CHOSE);
    number.tiedTo = $scope.search_number.tie;
    Numbers.buyNumber(number).then(function(response) {
      $scope.number = number;

      Api.bridges.fetch({limit: 100}, {cache: false}).then(function(){
        $scope.mode.showAll = true;
      });

      if(response.data.success) {
        $scope.LOADED = false;
        $scope.addNewLineModal.modal('hide');

        if(!number.tiedTo){
          $scope.configNumberModal = modals.configNumber($scope).modal();
        }
      }
    }).catch(function() {
        $scope.LOADED = false;

        $scope.SENT_REQUEST = false;
        $scope.numbers = [];
        $scope.reqError = 'Oops, we had a problem setting up this number. Please search again and try choosing a different number.';
        $scope.addNewLineModal.modal();
    }).then(function() {
      if ($scope.tollFreeModal && $scope.tollFreeModal.modal) {
        $scope.tollFreeModal.modal('hide');
        $scope.LOADED = false;
      }
    });
  };

  $scope.configThisNumber = function($event) {
    $event.preventDefault();

    var data = $.param({
      number: ($scope.number || {}).number,
      name: $scope.INFO.name
    });

    $http.post('/bridges/api/v1/set-bridge-name', data, {
      headers : {'Content-Type': 'application/x-www-form-urlencoded'}
    })
    .then(Api.bridges.fetch.bind(Api.bridges, {limit: 100}, {cache: false}))
    .then(function(response) {
      $scope.configNumberModal.modal('hide');

      // always show final step
      return $scope.showFinalStepModal();

      // // if the first number, launch the modal for add voiceover.
      // $scope.showVoiceoverNumberModal();
    }, function() {
      console.log("error config number");
    });
  };

  $scope.goToStepOne = function($event) {
    $scope.search_number.step = 1;
    if ($scope.userInfo.plan.number_type === 'tollfree') {
      $scope.showTollFreeNumbers($event);
    }
  };

  $scope.showFinalStepModal = function() {
    modals.numberAdded($scope).modal();
  };

  $scope.hide = function(modal) {
    $scope[modal].modal('hide');
  };
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/modals/add-record-controller.js
 ** module id = 344
 ** module chunks = 0
 **/